<template>
  <div class="deductionRuler">
    <Header :headerTitle="$t('m.deductionRuler.title')"></Header>
    <section>
      <!-- <p>{{$t('m.deductionRuler.tips')}}</p> -->
      <p class="title">{{$t('m.deductionRuler.orderRuler')}}</p>
      <b-row>
        <b-col cols="3">{{$t('m.deductionRuler.row00')}}</b-col>
        <b-col cols="3">{{$t('m.deductionRuler.row01')}}</b-col>
        <b-col cols="6">{{$t('m.deductionRuler.row02')}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="3">{{$t('m.deductionRuler.row10')}}</b-col>
        <b-col cols="3">{{$t('m.deductionRuler.row11')}}</b-col>
        <b-col cols="6">{{$t('m.deductionRuler.row12')}}</b-col>
      </b-row>
       <b-row>
        <b-col cols="3">{{$t('m.deductionRuler.row20')}}</b-col>
        <b-col cols="3">{{$t('m.deductionRuler.row21')}}</b-col>
        <b-col cols="6">{{$t('m.deductionRuler.row22')}}</b-col>
      </b-row>
        <b-row>
        <b-col cols="3">{{$t('m.deductionRuler.row30')}}</b-col>
        <b-col cols="3">{{$t('m.deductionRuler.row31')}}</b-col>
        <b-col cols="6">{{$t('m.deductionRuler.row32')}}</b-col>
      </b-row>
       <b-row>
        <b-col cols="3">{{$t('m.deductionRuler.row40')}}</b-col>
        <b-col cols="3">{{$t('m.deductionRuler.row41')}}</b-col>
        <b-col cols="6">{{$t('m.deductionRuler.row42')}}</b-col>
      </b-row>
        <b-row>
        <b-col cols="12">
          <p>{{$t('m.deductionRuler.notesTitle')}}</p>
          <ul>
            <li><span>●</span>{{$t('m.deductionRuler.li1')}}</li>
            <li><span>●</span>{{$t('m.deductionRuler.li2')}}</li>
          </ul>
        
        </b-col>
      </b-row>
    </section>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { timeOutPricingDetails } from "@/api/public.js";
export default {
  name: "deductionRuler",
  data() {
    return {
      overTimeList: {},
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //加载数据
    loadOverTimeList: function() {
      timeOutPricingDetails({}).then(
        response => {
          if (response.data.status == 200) {

          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  mounted() {
    // this.loadOverTimeList();
  }
};
</script>
<style scoped>
.deductionRuler{
  height: calc(100%);
  overflow: auto;
}
.deductionRuler section {
  width: 100%;
  padding: 10px;
}
.deductionRuler section p {
  font-size: 0.92rem;
  text-align: left;
  margin-bottom: 20px;
}
.deductionRuler section .title{
  color: rgb(160, 160, 160);
}
.deductionRuler section p span{
  color: darkcyan;
}
.deductionRuler section .row {
  padding: 0 15px;
    font-size: 0.91rem;
}
.deductionRuler section .row .col-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
   margin-right: 4.5px;
   max-width: 23.5%; 
}
.deductionRuler section .row .col-6{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
}
.deductionRuler section .row .col-12 {
  background-color: #f1f1f1;
  margin-bottom: 3px;
  padding: 0 1px;
}
.deductionRuler section .row .col-12 p{
  margin: 0;
  font-size: 0.93rem;
}
.deductionRuler section .row .col-12 ul{
  margin: 0;
  padding:0;
  font-size: 0.90rem;
  text-align: left;

}
.deductionRuler section .row .col-12 ul li span{
  float: left;
  margin-top: -1px;
  padding-right: 4px;
}
</style>


